import 'es6-promise/auto'
import axios from 'axios'

const origin = location.origin.match(/localhost/) ? 'http://cominca.test' : location.origin;

const api = axios.create({
  timeout: 10000,
  baseURL: process.env.baseUrl || `${origin}/wp-json/wp/v2`
});

api.interceptors.request.use( config => {
  let nonce = '';
  if(window.WP_API_Settings && window.WP_API_Settings.nonce) {
    nonce = window.WP_API_Settings.nonce
  }

  if(config.headers instanceof Object) {
    config.headers['X-WP-Nonce'] = nonce
  }

  return config;
})

export default {
  // existsCache: () => {
  // },
  // checkStatus: () => {
  // },
  fetchInfo: async (slug, params={}) => {
    if(!slug) { slug = 'top' }

    const { data } = await api.get(`/page-info/${slug}`, { params: params });
    return data
  },
  fetchPosts: async (option={}) => {
    const mold = {
      type: 'destination',
      id: '',
      params: {}
    };

    const fix = Object.assign(mold, option);
    const result = await api.get(`/${fix.type}/${fix.id}`, { params: fix.params });
    // console.log(result);

    return { data: result.data, headers: result.headers }
  },
  // fetchSideNav: async(option={}) => {
  //   const result = await api.get(`/side-nav-menu/${option.name}`, { params: option.params });
  //   return { data: result.data, headers: result.headers }
  // }
}



// WEBPACK FOOTER //
// ./src/api/index.js